import React from "react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";
import entityColor from "@util/entityColor";

export default function UserGroupForm({ info, id, onSuccess, reqData }) {
  function onSubmit(formData) {
    if (id) return updateMutation.mutate(formData);

    return createMutation.mutate(formData);
  }

  const createMutation = useMutation({
    mutationFn: (formData) => {
      return axios.post(`/user-groups/`, { ...formData, ...reqData });
    },
    onSuccess: () => {
      toast.success("Created!");
      onSuccess();
    },
    onError: (err) => {
      toast.error(err);
    },
  });

  const updateMutation = useMutation({
    mutationFn: (formData) => {
      return axios.put(`/user-groups/${id}/`, { ...formData, ...reqData });
    },
    onSuccess: () => {
      toast.success("Updated!");
      onSuccess();
    },
    onError: (err) => {
      toast.error(err);
    },
  });

  const formLoading = createMutation.isPending || updateMutation.isPending;

  const fields = [
    {
      name: "name",
      label: "A memorable title",
      initialValue: info?.name || "",
      required: true,
      schema: () => Yup.string().max(255, "Too long!").required("Required"),
    },
    {
      name: "description",
      label:
        "How would you describe this group? (or a way to remember it later)",
      initialValue: info?.description || "",
      textarea: true,
      required: true,
      schema: () => Yup.string().max(255, "Too long!").required("Required"),
    },
  ];

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id ? true : true,
        color: entityColor.user,
      }}
      loading={formLoading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
